export default function Reglage() {
  const reglages = [
    "Vérification de la tension du ressort d'équilibrage ou du contrepoids du tablier",
    "Alignement des lames dans les coulisses pour éviter les frottements latéraux",
    "Réglage des butées haute et basse pour stopper le tablier aux bonnes positions",
    "Graissage des glissières et des joints de coulisse avec produit adapté au PVC ou aluminium",
    "Test de montée et descente complète sans à-coup ni point dur sur toute la course",
    "Vérification de l'anti-retour : le tablier doit rester en position sans descendre seul",
  ];

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Réglage et remise en service
        </h2>
        <p className="text-brand-text leading-relaxed mb-4">
          Après le remplacement d'un treuil, d'un cardan ou d'une sortie de caisson, le volet roulant ne doit pas seulement fonctionner : il doit fonctionner correctement. Un réglage précis est indispensable pour garantir une manœuvre fluide, une usure minimale des nouvelles pièces et une sécurité optimale. Un mauvais réglage peut provoquer une surcharge du mécanisme neuf et entraîner une nouvelle casse prématurée.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          Nos techniciens procèdent à une série de réglages systématiques après chaque intervention sur manivelle. Nous vérifions la tension du tablier, l'alignement dans les coulisses, les butées de fin de course, le graissage des glissières et le fonctionnement de l'anti-retour. Ces réglages s'appliquent aussi bien aux volets roulants en PVC, aluminium ou bois, qu'aux tabliers en lames pleines ou ajourées.
        </p>

        <div className="bg-brand-light rounded-xl border border-brand-border p-6 md:p-8">
          <h3 className="text-lg font-semibold text-brand-blue mb-6 flex items-center gap-2">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-cyan/10 text-brand-cyan">
              <i className="ri-settings-3-line"></i>
            </span>
            Points de réglage vérifiés après intervention
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {reglages.map((r, i) => (
              <div key={i} className="flex items-start gap-3 bg-white rounded-lg p-4 border border-brand-border">
                <i className="ri-check-line text-brand-cyan mt-0.5 shrink-0"></i>
                <p className="text-sm text-brand-text leading-relaxed">{r}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 bg-white rounded-xl border border-brand-border p-5">
          <h3 className="text-lg font-semibold text-brand-blue mb-3">
            Pourquoi le réglage est aussi important que le remplacement
          </h3>
          <p className="text-sm text-brand-text leading-relaxed mb-3">
            Un treuil neuf installé sur un tablier mal équilibré ou des coulisses encrassées va forcer dès les premières manœuvres. La surcharge mécanique réduit la durée de vie du nouveau mécanisme de 30 à 50 %. C'est pourquoi nous ne remplaçons jamais une pièce sans inspecter l'ensemble du système : tablier, coulisses, équilibrage et fin de course.
          </p>
          <p className="text-sm text-brand-text leading-relaxed">
            Notre objectif est que vous ne nous rappeliez pas pour la même panne. Chaque intervention sur manivelle inclut donc un contrôle complet du volet, avec des conseils d'entretien pour préserver la longévité du mécanisme : graissage annuel, nettoyage des coulisses, et vérification de la tension du tablier tous les deux ans.
          </p>
        </div>
      </div>
    </section>
  );
}